//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from '@/modules/partner/components/sama-el-baraka/header.vue';
import Footer from '@/modules/partner/components/sama-el-baraka/footer.vue';
import Title from '@/modules/partner/components/sama-el-baraka/title.vue';
import Products from '@/modules/partner/components/sama-el-baraka/products.vue';
import Branches from '@/modules/partner/components/sama-el-baraka/branches.vue';
import Contact from '@/modules/partner/components/sama-el-baraka/contact.vue';
import i18n from '@/vueI18n';

export default {
  components: {
    [Header.name]: Header,
    [Footer.name]: Footer,
    [Title.name]: Title,
    [Products.name]: Products,
    [Branches.name]: Branches,
    [Contact.name]: Contact,
  },
  computed: {
    language() {
      return i18n.locale;
    },
  },
  watch: {
    language() {
      document.title = this.i18n('app.samaElBaraka');
    },
  },
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
  },
};
